<h2 class="font-bold text-2xl text-gray-600 my-2" [ngClass]="router.url == '/' ? 'hidden': 'block'">Enquire Now</h2>
<form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="mx-auto">
    <div class="mb-4">
        <label for="name" class="block text-sm font-medium text-gray-700">Name <small class="text-red-500">*</small></label>
        <input type="text" id="name" formControlName="fullName"
               class="mt-1 p-2 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
        <small *ngIf="submitted && enquiryForm.get('fullName')?.hasError('required') || enquiryForm.get('fullName')?.touched"
             class="text-red-500">
            Name is required.
        </small>
    </div>
    <div class="md:flex gap-3">
        <div class="w-full md:w-1/2">
            <div class="mb-4">
                <label for="contact" class="block text-sm font-medium text-gray-700">Phone <small class="text-red-500">*</small></label>
                <input type="number" id="contact" formControlName="contact"
                       class="mt-1 p-2 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
                <small *ngIf="submitted && enquiryForm.get('contact')?.hasError('required') || enquiryForm.get('contact')?.touched"
                     class="text-red-500">
                    Contact number is required.
                </small>
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="mb-4">
                <label for="email" class="block text-sm font-medium text-gray-700">Email Address <small class="text-red-500">*</small></label>
                <input type="email" id="email" formControlName="email"
                       class="mt-1 p-2 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
                <small
                    *ngIf="submitted && enquiryForm.get('email')?.hasError('required') || enquiryForm.get('email')?.touched"
                     class="text-red-500">
                    Email is required.
                </small>
                <small *ngIf="submitted && enquiryForm.get('email')?.hasError('email')" class="text-red-500">
                    Invalid email format.
                </small>
            </div>
        </div>
    </div>
    <div class="md:flex gap-3">
        <div class="w-full md:w-1/2">
            <div class="mb-4">
                <label for="address" class="block text-sm font-medium text-gray-700">Address <small class="text-red-500">*</small></label>
                <input type="text" id="address" formControlName="address"
                       class="mt-1 p-2 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
                <small *ngIf="submitted && enquiryForm.get('address')?.hasError('required') || enquiryForm.get('address')?.touched"
                     class="text-red-500">
                    Address is required.
                </small>
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="">
                <div class="relative mt-6">
                    <button (click)="toggleDropdown()" class="w-full px-4 py-2 text-gray-500 border border-gray-300 rounded-md shadow-sm bg-white text-left flex justify-between items-center">
                        {{ selectedCourse?.name || 'Select a Course' }}
                        <span [class.rotate-180]="isDropdownOpen" class="transition-transform">▼</span>
                    </button>
                    <ul *ngIf="isDropdownOpen" class="absolute px-3 w-full text-gray-700 border border-gray-300 h-48 overflow-y-scroll rounded-md shadow-lg bg-white mt-1 z-10">
                        <li *ngFor="let course of courses" (click)="selectCourse(course)" class=" p-2 hover:bg-gray-200 cursor-pointer">
                            {{ course.name }}
                        </li>
                    </ul>
                    <small *ngIf="submitted && !selectedCourse" class="text-red-500">
                        Course is required.
                    </small>
                </div>
            </div>
        </div>
    </div>
    <div [ngClass]="router.url == '/' ? 'text-center pt-4 border-t': 'pt-6x'">
        <button type="submit" class="bg-[#ff7a59]  hover:bg-[#ff8573] text-white font-bold py-2 px-5 text-sm rounded">
            Submit
        </button>
    </div>
</form>
